import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"


const TablaHistoricoLicores = (props) => {

    let op = require('../../../../src/modulos/datos');

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [deuda, setDeuda] = useState();
    const [interes, setInteres] = useState();
    const [recargo, setRecargo] = useState();
    const [multa, setMulta] = useState();
    const [totDeuda, setTotDeuda] = useState();
    const [credito, setCredito] = useState(0.00);


    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });

    const headCells = [
        { id: 'anio', label: 'AÑO', width: '130px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'mes', label: 'MES', width: '130px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'descripcion', label: 'DESCRIPCION', width: '300px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'monto', label: 'MONTO', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'numrecibo', label: 'N° RECIBO', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'fechapag', label: 'FECHA DE PAGO', width: '200px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
       
    ];

    let heightTabla = 320;

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);


    useEffect(() => {


        if (props.tabHis) {
            setRecords(props.tabHis);
        }

    }, [props.tabHis]);




    return (
        <div >
            <div className="card-body mx-auto" style={{ height: "100%", margin:0, padding:0 }}>
                <div className="content" >
                    <div className="container">
                        <div className="row col-md-12" style={{ height: "100%" }}>
                     
                                <div className="col-md-12">
                                <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                        <TblHead />

                                        <tbody>
                                            {

                                                records && records.map((item, index) => (
                                                    <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.anio}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.mes}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.descripcion }</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{item.monto == null ? "0,00" : formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.numereci }</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.fechapago }</td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                </div>
                                
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaHistoricoLicores;
